export default {"src":"/_next/static/media/Sports Injuries.b37fce4a.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};